import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithBaseUrl } from "./baseQuerySlice";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithBaseUrl,
  tagTypes: [
    "Institutions",
    "userProfile",
    "userBio",
    "userEducation",
    "userExperience",
    "marketplaceListings",
    "marketplaceRecommendations",
    "marketplaceMyListings",
    "studyGroups",
    "communityPosts",
    "DiscoverMeshes",
    "MyMeshes",
    "MeshDetails",
    "MeshMessages",
    "CampusSpots",
    "jobsList",
    "jobDetail",
    "myBookmarks",
    "myApplications",
    "ProfilePosts",
    "userResume",
    "connectionsCount",
    "studyCount",
    "communityCount",
    "TopOrganizers"
  ],
  endpoints: () => ({}),
});
